import { render, staticRenderFns } from "./Scene5.vue?vue&type=template&id=0ed14c2d&scoped=true"
import script from "./Scene5.vue?vue&type=script&lang=js"
export * from "./Scene5.vue?vue&type=script&lang=js"
import style0 from "./Scene5.vue?vue&type=style&index=0&id=0ed14c2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed14c2d",
  null
  
)

export default component.exports